/**
 * Lutfiye orijinal logo — kullanıcı tarafından sağlanan PNG.
 * CSS mask kullanarak istenen renkte gösterilir.
 */
export default function LutfiyeLogo({
  className = '',
  color = 'text-[#1F1F1F]',
  width = 'w-32 md:w-40',
  height = 'h-10 md:h-12',
}) {
  return (
    <span
      className={`inline-block ${width} ${height} ${color} ${className}`}
      style={{
        WebkitMaskImage: "url('/lutfiye-logo.png')",
        maskImage: "url('/lutfiye-logo.png')",
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        maskPosition: 'center',
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
        backgroundColor: 'currentColor',
      }}
      role="img"
      aria-label="Lutfiye"
    />
  );
}
